import React, { useReducer, useEffect } from "react";
import { Table, Row, Col, Button, Alert, Accordion } from "react-bootstrap";
import ModuleDisplayEmail from "../modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayPhone from "../modules/fieldsDisplay/ModuleDisplayPhone";
import {
  listingInitialState,
  listingReducer,
} from "../../../reducers/module/listingReducer";
import axios from "../../../config/axios";
import { BsBoxSeam, BsClock, BsClockHistory } from "react-icons/bs";
import { getCurrencyCode, getFullName } from "../../../helpers/CommonHelper";
import ModuleDisplayDateTime from "../modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayBoolean from "../modules/fieldsDisplay/ModuleDisplayBoolean";
import { Link, useNavigate } from "react-router-dom";
import { FullPageOverlay } from "../loading/FullPageOverlay";

import StatsListing from "../shared/infoListing/StatsListing";
import moduleConfig from "../../modules/orders/moduleConfig";
import ModuleDisplayDate from "../modules/fieldsDisplay/ModuleDisplayDate";
import { FaCheck, FaClock, FaShoppingCart, FaUser } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { BiCartAdd, BiCheck, BiCheckCircle } from "react-icons/bi";
import { GiClockwork, GiMeal } from "react-icons/gi";
function CustomerContent({ setParent, parent }) {
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );

  const navigate = useNavigate();

  const handleNavigate = (url) => {
    navigate(url);
  };
  const loadItems = async () => {
    listingDispatch({ type: "FETCH_REQUEST" });
    setParent(true);

    try {
      // First API call
      const res1 = await axios.get(`customers/get-stats`);

      // Second API call (after first)
      const res2 = await axios.get(`customers?limit=5`);

      // Combine both API data if needed
      const combinedData = {
        stats: res1.data?.stats,
        items: res2.data?.items,
      };

      listingDispatch({
        type: "FETCH_SUCCESS",
        payload: combinedData,
      });
    } catch (error) {
      listingDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    } finally {
      setParent(false);
    }
  };

  useEffect(() => {
    loadItems();
  }, []);

  return (
    <>
      <Row className="my-2">
        <Col>
          {/* {listingState.isFetching === true && <FullPageOverlay />}
          {console.log(listingState.data)} */}
          {listingState.hasFetchingError && (
            <Alert variant="warning mb-0 mt-1">
              OOPS!!! Something went wrong, please try again later.
            </Alert>
          )}
          {listingState.data && listingState?.data?.stats && (
            <>
              <Row className="my-2">
                <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                  <a
                    onClick={() => handleNavigate(`/customers`)}
                    title="Please click to view all customers"
                  >
                    <div className="info-box bg-linear-6 text-white">
                      <span className="info-box-icon">
                        <FaUser size={40} />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Total Customers</span>
                        <span
                          className="info-box-number fs-3"
                          style={{ lineHeight: "30px" }}
                        >
                          {listingState?.data?.stats?.total}
                        </span>
                      </div>
                    </div>
                  </a>
                </Col>

                <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                  <a
                    onClick={() => handleNavigate(`/customers?has=orders`)}
                    title="Please click to view customers with orders"
                  >
                    <div className="info-box bg-linear-2 text-white">
                      <span className="info-box-icon">
                        <BsBoxSeam size={40} />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">
                          Customers with orders
                        </span>
                        <span
                          className="info-box-number fs-3"
                          style={{ lineHeight: "30px" }}
                        >
                          {listingState?.data?.stats?.havingOrders}
                        </span>
                      </div>
                    </div>
                  </a>
                </Col>
                <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                  <a
                    onClick={() =>
                      handleNavigate(`/customers?has=subscriptions`)
                    }
                    title="Please click to view customers with subscriptions"
                  >
                    <div className="info-box bg-linear-5 text-white">
                      <span className="info-box-icon">
                        <GiMeal size={40} />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">
                          Customers with subscriptions
                        </span>
                        <span
                          className="info-box-number fs-3"
                          style={{ lineHeight: "30px" }}
                        >
                          {listingState?.data?.stats?.havingSubscriptions}
                        </span>
                      </div>
                    </div>
                  </a>
                </Col>
              </Row>
            </>
          )}
          {listingState?.data?.items &&
            listingState?.data?.items?.length > 0 && (
              <Row>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h5 className="text-bold fs-9 ">Recent Customers</h5>
                      {/* <p className="mb-0 text-white font-italic fs-12 text-left heartbeat hide  mb-0">Admin Action Required</p> */}
                    </div>
                    <div>
                      <Link
                        to={"/customers"}
                        className="btn btn-xs btn-custom-2 fontItalic"
                      >
                        {" "}
                        View More
                      </Link>
                    </div>
                  </div>

                  <div className="overflow-x-auto mt-0">
                    <table class="custom-table mt-1">
                      <thead>
                        <tr>
                          <th>Full Name</th>
                          <th>Email</th>
                          <th class="text-center">Phone</th>
                          <th class="text-center">No. of Orders</th>
                          <th class="text-center">No. of Subscriptions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {listingState?.data?.items.map((item, index) => {
                          return (
                            <tr
                              title="View details"
                              onClick={() =>
                                handleNavigate(`/customers/${item._id}`)
                              }
                            >
                              <td>
                                {item?.firstName} {item?.lastName}
                              </td>
                              <td>
                                <ModuleDisplayEmail value={item?.email} />
                              </td>
                              <td className="text-center">
                                <ModuleDisplayPhone value={item?.mobile} />
                              </td>
                              <td className="text-center text-custom-1 text-bold">
                                {item?.ordersCount}
                              </td>
                              <td className="text-center">
                                {item?.subscriptionsCount}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
            )}
        </Col>
      </Row>
    </>
  );
}

export default CustomerContent;
